// ------------------------------
// IMAGE REVEAL: Slide-Up Animation
// Applies to all elements using `.image-reveal-inner`
// Scoped to `.layout-feature-image_component` blocks to allow multiple independent triggers.
// ------------------------------
document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not loaded');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  const isMobile = window.innerWidth < 768;

  // Loop through each section containing reveal images
  document.querySelectorAll('.layout-feature-image_component').forEach((section) => {
    const items = section.querySelectorAll('.image-reveal-sinner');

    if (items.length === 0) return;

    gsap.to(items, {
      clipPath: 'inset(0% 0% 0% 0%)',
      webkitClipPath: 'inset(0% 0% 0% 0%)',
      duration: 0.5,
      ease: 'power2.in',
      stagger: {
        each: isMobile ? 0.05 : 0.25, // Less delay on mobile
        from: 'start'
      },
      scrollTrigger: {
        trigger: section,
        start: 'top 80%', // Starts animation when 80% of section is in view
        toggleActions: 'play none none none'
      }
    });
  });
});


// ------------------------------
// IMAGE REVEAL: Center-Out Animation
// Applies to elements using `.image-reveal-center`
// Used where images open like a mask from the center outward.
// ------------------------------
document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const items = gsap.utils.toArray('.image-reveal-center');

  items.forEach((el) => {
    gsap.to(el, {
      clipPath: 'inset(0% 0% 0% 0%)',
      webkitClipPath: 'inset(0% 0% 0% 0%)',
      duration: 0.4,
      ease: 'power2.in',
      scrollTrigger: {
        trigger: el,
        start: 'top 85%', // Triggers when image is near entering the viewport
        toggleActions: 'play none none none'
      }
    });
  });
});


// ------------------------------
// INVERTED PARALLAX BACKGROUND SCROLL EFFECT
// Image starts higher (above) and scrolls down into place
// ------------------------------
document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const bgImages = document.querySelectorAll('.layout_background-image');

  bgImages.forEach((img) => {
    gsap.fromTo(
      img,
      { y: '0vh' }, // Starts much lower
      {
        y: '0vh', // Scrolls upward dramatically
        ease: 'none',
        scrollTrigger: {
          trigger: img.closest('.section_main'),
          start: 'top 90%', // ⬅️ Offset start later (e.g., when 10% of section is visible)
          end: 'bottom top',
          scrub: true
        }
      }
    );
  });
});



// ------------------------------
// PARALLAX 3 TEMPLE IMAGES
// ------------------------------


document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const movingImages = document.querySelectorAll('.parallax-image-inner');

  movingImages.forEach((imgWrapper) => {
    gsap.to(imgWrapper, {
      y: -80, // subtle downward motion
      ease: 'none',
      scrollTrigger: {
        trigger: imgWrapper.closest('.cocktail-related_item'),
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    });
  });
});


